import { Grid } from '@material-ui/core';
import { StatRow } from '@screens/players/stat.display';
import React from 'react';
import { formatStringDate } from '@domain/utils/format.utils';
import { TourneyDataProps } from './tourney.data.props';

const TourneyInfosPraia = ({ tourneyInfo }: TourneyDataProps) => {
  const formatStartDate = formatStringDate(tourneyInfo.startDate || '');
  const formatEndDate = formatStringDate(tourneyInfo.endDate || '');
  return (
    <div style={{ padding: 20 }}>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Tourney Id'>{tourneyInfo.tourneyId}</StatRow>
        </Grid>
        <Grid item xs>
          <StatRow label='Start Date'>{formatStartDate}</StatRow>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Game'>{tourneyInfo.gameId}</StatRow>
        </Grid>
        <Grid item xs>
          <StatRow label='End Date'>{formatEndDate}</StatRow>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Type'>{tourneyInfo.type}</StatRow>
        </Grid>
      </Grid>
    </div>
  );
};

export default TourneyInfosPraia;
